import detailContrat from '@/views/baux/contrat/c_contrat';
import listeContrat from '@/views/baux/contrat/l_contrat';
import ajoutContrat from '@/views/baux/contrat/m_contrat';
import ChoixSousTypeBailleur from '@/views/baux/bailleur/m_choixSousTypeBailleur';
import AjoutBailleur from '@/views/baux/bailleur/m_bailleur';
import DetailBailleur from '@/views/baux/bailleur/c_bailleur';
import listeBailleur from '@/views/baux/bailleur/l_bailleur';
import ConstatationCharge from '@/views/baux/constatationCharge/l_constatationCharge';
import ListeEcheancesAPayer from '@/views/baux/paiement/l_echeancesAPayer';
import ListelotPaiement from '@/views/baux/lotPaiement/l_lotPaiement';
import DetailLotPaiement from '@/views/baux/lotPaiement/c_lotPaiement';
import DepenseBailleurEdition from '@/views/baux/depenseBailleur/m_depenseBailleur';
import ListeFactureAchatBailleur from '@/views/baux/depenseBailleur/l_depenseBailleur';
import DepenseBailleurConsulatation from '@/views/baux/depenseBailleur/c_depenseBailleur';
import editLotPaiement from '@/views/baux/lotPaiement/m_lotPaiement';
import ListeFactureAchat from '@/views/baux/factureAchat/l_factureAchat';
import ajoutMateriel from '@/components/baux/contrat/componentEdition/ajoutMateriel';
import infosBailleur from '@/components/baux/bailleur/detailBailleur/detailBailleur';
import ecranNumeriqueBailleur from '@/components/baux/bailleur/detailBailleur/ecranNumeriqueBailleur';
import faceBailleur from '@/components/baux/bailleur/detailBailleur/faceBailleur';
import encoursBailleur from '@/components/baux/bailleur/detailBailleur/m_EnCoursBailleur';
import listeContratBailleur from '@/components/baux/contrat/listeContrat';
import compteBailleur from '@/components/baux/bailleur/detailBailleur/m_CompteBailleur';
import ListeDemarcheur from '@/views/baux/demarcheur/l_demarcheur';
import editionFournisseur from '@/views/commun/fournisseur/m_fournisseur';
import detailFournisseur from '@/views/commun/fournisseur/c_fournisseur';
import listeCommandeAchatBailleur from '@/views/baux/commandeAchat/l_commandeAchat';
import detailCommandeAchatBailleur from '@/views/baux/commandeAchat/c_commandeAchatBailleur';
import editCommandeAchatBailleur from '@/views/baux/commandeAchat/m_commandeAchatBailleur';

export default [
  {
    path: '/bailleur',
    component: listeBailleur,
    name: 'l.baux.bailleur',
  },
  {
    path: 'detailBaux/:id',
    component: detailContrat,
    name: 'c.baux.contrat',
  },
  {
    path: 'ajoutBaux',
    component: ajoutContrat,
    name: 'm.baux.contrat-ajout',
  },
  {
    path: 'editionBaux/:id',
    component: ajoutContrat,
    name: 'm.baux.contrat-edit',
  },
  {
    path: 'listeBaux',
    component: listeContrat,
    name: 'l.baux.contrat',
  },
  {
    path: 'listeBauxByTiers/:id',
    component: listeContrat,
    name: 'l.baux.contrat-by-tiers',
  },
  {
    path: 'listeBauxByMateriel/:typePatrimoine/:patrimoineId',
    component: listeContrat,
    name: 'l.baux.contrat-by-materiel',
  },
  {
    path: 'choixBailleur',
    component: ChoixSousTypeBailleur,
    name: 'm.baux.bailleur-choixSousType',
  },
  {
    path: 'ajoutBailleur/:sousType',
    component: AjoutBailleur,
    name: 'm.baux.bailleur-ajout',
  },
  {
    path: 'editionBailleur/:id',
    component: AjoutBailleur,
    name: 'm.baux.bailleur-edit',
  },
  {
    path: 'detailBailleur/:id',
    component: DetailBailleur,
    children: [
      {
        path: '',
        component: infosBailleur,
        name: 'c.baux.bailleur',
      },
      {
        path: 'baux',
        component: listeContratBailleur,
        name: 'c.baux.bailleur-contrat',
      },
      {
        path: 'ecrans',
        component: ecranNumeriqueBailleur,
        name: 'c.baux.bailleur-ecrans',
      },
      {
        path: 'faces',
        component: faceBailleur,
        name: 'c.baux.bailleur-faces',
      },
      {
        path: 'encours',
        component: encoursBailleur,
        name: 'c.baux.bailleur-enCours',
      },
      {
        path: 'compte',
        component: compteBailleur,
        name: 'c.baux.bailleur-compte',
      },
    ],
  },
  {
    path: 'constatationCharge',
    component: ConstatationCharge,
    name: 'l.baux.constatation_charge',
  },
  {
    path: 'listeEcheancesAPayer',
    component: ListeEcheancesAPayer,
    name: 'l.baux.echeancier_contrat',
  },
  {
    path: 'detailFactureBailEcheancier/:id/:idCommandeAchat',
    component: detailContrat,
    name: 'c.baux.contrat-facture-in-echeancier',
  },
  {
    path: '/listeLotPaiement/:idsLots?',
    component: ListelotPaiement,
    name: 'l.baux.lot_paiement',
  },
  {
    path: '/detailLotPaiement/:id',
    component: DetailLotPaiement,
    name: 'c.baux.lot_paiement',
  },
  {
    path: '/editLotPaiement/:id',
    component: editLotPaiement,
    name: 'm.baux.lot_paiement',
  },
  {
    path: '/listeDepenseBailleur/:idDevisCommande?',
    component: ListeFactureAchatBailleur,
    name: 'l.baux.facture_achat-bailleur',
  },
  {
    path: '/listeDepenseBailleur/:idsFactures?',
    component: ListeFactureAchatBailleur,
    name: 'l.baux.facture_achat-bailleur-idsFactures',
  },
  {
    path: '/listeFactureAchat/:idDevisCommande?',
    component: ListeFactureAchat,
    name: 'l.baux.facture_achat',
  },
  {
    path: '/listeFactureAchat/:idsFactures?',
    component: ListeFactureAchat,
    name: 'l.baux.facture_achat-idsFactures',
  },
  {
    path: '/depenseBailleurEdition/:id/:aRapprocher?',
    component: DepenseBailleurEdition,
    name: 'm.baux.facture_achat-edition',
  },
  {
    path: '/depenseBailleurCreation',
    component: DepenseBailleurEdition,
    name: 'm.baux.facture_achat-creation',
  },
  {
    path: '/creer-avoir-bailleur',
    component: DepenseBailleurEdition,
    name: 'm.baux.facture_achat-avoir',
  },
  {
    path: '/depenseBailleurCreationViaBail/:idBail/:tiersId',
    component: DepenseBailleurEdition,
    name: 'm.baux.facture_achat-creation-via-bail',
  },
  {
    path: '/depenseBailleurConsultation/:id',
    component: DepenseBailleurConsulatation,
    name: 'c.baux.facture_achat',
  },
  {
    path: '/depenseBailleurSaveToEdit/:id/:aRapprocher?',
    component: DepenseBailleurEdition,
    name: 'm.baux.facture_achat-save-to-edit',
  },
  {
    path: '/ajoutMateriel',
    component: ajoutMateriel,
    name: 'l.baux.contrat-ajout-materiel',
  },
  {
    path: '/demarcheur',
    component: ListeDemarcheur,
    name: 'l.baux.demarcheur',
  },
  {
    path: '/ajoutFournisseur/:sousTypeFrom',
    component: editionFournisseur,
    name: 'm.baux.demarcheur',
  },
  {
    path: '/detailTechnicien/:id/:sousTypeFrom',
    component: detailFournisseur,
    name: 'c.baux.demarcheur',
  },
  {
    path: '/editionFournisseur/:id/:sousTypeFrom',
    component: editionFournisseur,
    name: 'm.baux.demarcheur-edition',
  },
  {
    path: '/listeCommandeAchatBailleur',
    component: listeCommandeAchatBailleur,
    name: 'l.baux.commande_achat-bailleur',
  },
  {
    path: '/detailCommandeAchatBailleur/:id',
    component: detailCommandeAchatBailleur,
    name: 'c.baux.commande_achat-bailleur',
  },
  {
    path: '/editCommandeAchatBailleur/:id',
    component: editCommandeAchatBailleur,
    name: 'm.baux.commande_achat-bailleur',
  },
];
